import { createStore } from 'vuex'

export const store = createStore({
  state () {
    return {
        pageNum: 1,
        company: {
          name: ''
        },
        //lifeCover: 99, 
        percentageGain: 20,
        lapseRate: 25,
        currentRevenues:{
            mortgages:{
                monthlyAvgSignup: 0,
                appFee: 0
            },
            life:{
                cases: 0,
                avgPremium: 0,
                avgCommission: 0
            },
            bins:{
                cases: 0,
                avgPremium: 0,
                avgCommission: 0
            }
        },
        overheads: { 
            premises: Number(0),
            phone: Number(0),
            insurance: Number(0),
            staff: Number(0),
            salary: Number(0),
            tax: Number(0),
            other: Number(0)
        },
        projected:{
          submissions:Number(0),
          submittedAbandonments:Number(0),
          immediateOnRisk:Number(0),
          abandonmentsBeforeAdmin:Number(0),
        },
        charges:{
          submittedWithAdmin:Number(95),
          submittedImmediateOnRisk:Number(69),
          abandoned:Number(29),
        }
    }
  },
  getters: {
    conversionRate (state) {
      return state.currentRevenues.mortgages.monthlyAvgSignup> 0 
        ? (100 / state.currentRevenues.mortgages.monthlyAvgSignup) * state.currentRevenues.life.cases
        : 0
    },
    multiplier (state) {
        return ((state.percentageGain / 100) + 1)
    },
    projectedConversionRate (state,getters) {
        return getters.conversionRate * getters.multiplier
    },
    mortgageCases (state) {
        return state.currentRevenues.mortgages.monthlyAvgSignup
    },
    totalOverheads (state)  {
        return state.overheads.premises + 
          state.overheads.phone + 
          state.overheads.insurance + 
          state.overheads.staff + 
          state.overheads.salary + 
          state.overheads.tax + 
          state.overheads.other
    },
    projectedSubmissionsWithAdmin (state,getters) {
      console.log('state.currentRevenues.mortgages.monthlyAvgSignup: ' + state.currentRevenues.mortgages.monthlyAvgSignup)
      console.log('getters.projectedConversionRate: ' + getters.projectedConversionRate)
      var multiplier = getters.projectedConversionRate > 0 ? (getters.projectedConversionRate / 100) * 0.28 : 0
      console.log('multiplier: ' + multiplier)
      return Math.round(state.currentRevenues.mortgages.monthlyAvgSignup * multiplier)
    },
    projectedAbandonments (state,getters) {
      var multiplier = getters.projectedConversionRate > 0 ? (getters.projectedConversionRate / 100) * 0.07 : 0
      return Math.round(state.currentRevenues.mortgages.monthlyAvgSignup * multiplier)
    },
    projectedImmediateOnRisk (state,getters) {
      var multiplier = getters.projectedConversionRate > 0 ? (getters.projectedConversionRate / 100) * 0.57 : 0
      return Math.round(state.currentRevenues.mortgages.monthlyAvgSignup * multiplier)
    },

    projectedSubmissionWithAdminCost (state,getters) {
      return state.charges.submittedWithAdmin * getters.projectedSubmissionsWithAdmin
    },
    projectedImmediateOnRiskCost (state,getters) {
      return state.charges.submittedImmediateOnRisk * getters.projectedImmediateOnRisk
    },
    projectedAbandonmentsCost (state,getters) {
      return state.charges.abandoned * getters.projectedAbandonments
    },

    projectedTotalCost (state, getters) {
      return getters.projectedAbandonmentsCost + getters.projectedSubmissionWithAdminCost + getters.projectedImmediateOnRiskCost
    },
    currentMortgageIncome (state) {
        return state.currentRevenues.mortgages.monthlyAvgSignup * state.currentRevenues.mortgages.appFee
    },
    currentLifeIncome (state) {
        return state.currentRevenues.life.cases * state.currentRevenues.life.avgCommission
    },
    currentLapseProvisions (state, getters) {
      var multiplier = state.lapseRate > 0 ? (state.lapseRate / 100) : 0
      return getters.currentLifeIncome * multiplier
    },
    currentBinsIncome (state) {
        return state.currentRevenues.bins.cases * state.currentRevenues.bins.avgCommission
    },
    currentAnnualIncome (state, getters) {
        return (getters.currentMortgageIncome + getters.currentLifeIncome + getters.currentBinsIncome) * 12
    },
    currentAnnualLapseProvisions (state, getters) {
        return getters.currentLapseProvisions * 12
    },
    currentAnnualCosts(state, getters) {
      return getters.totalOverheads * 12
    },
    currentAnnualProfit (state, getters) {
        return getters.currentAnnualIncome - getters.currentAnnualCosts - getters.currentAnnualLapseProvisions
    },
    projectedMortgageIncome (state, getters) {
        return state.currentRevenues.mortgages.monthlyAvgSignup * getters.multiplier * state.currentRevenues.mortgages.appFee
    },
    projectedLifeIncome (state, getters) {
        return state.currentRevenues.life.cases * getters.multiplier * state.currentRevenues.life.avgCommission
    },
    projectedBinsIncome (state, getters) {
        return state.currentRevenues.bins.cases * getters.multiplier * state.currentRevenues.bins.avgCommission
    },
    projectedLapseProvisions (state, getters) {
      var multiplier = state.lapseRate > 0 ? (state.lapseRate / 100) : 0
      return getters.projectedLifeIncome * multiplier
    },
    projectedAnnualIncome(state, getters) {
      return (getters.projectedMortgageIncome + getters.projectedLifeIncome + getters.projectedBinsIncome) * 12
    },
    projectedAnnualCosts(state, getters) {
      return (getters.totalOverheads + getters.projectedTotalCost ) * 12
    },
    projectedAnnualProfit (state, getters) {
        return getters.projectedAnnualIncome - getters.projectedAnnualCosts - getters.projectedAnnualLapseProvisions
    },
    projectedAnnualLapseProvisions (state, getters) {
        return getters.projectedLapseProvisions * 12
    },
    overheads (state, getters) {
        return getters.totalOverheads
    },
    companyName (state){
      return state.company.name
    }
  },
  mutations: {
    nextPage (state) {
      state.pageNum++
    },
    backPage(state) {
      state.pageNum--
    },
    setCompanyName (state, v) {
      state.company.name = v
    },
    setMonthlyAvgMortgageSignup (state, v) {
      state.currentRevenues.mortgages.monthlyAvgSignup = Number(v)
    },
    setLapseRate (state, v) {
      state.lapseRate = Number(v)
    },
    setPercentageGain (state, v) {
      state.percentageGain = Number(v)
    },
    setAppFee (state, v) {
      state.lifeCoverX = v;
      state.currentRevenues.mortgages.appFee = Number(v)
    },
    setLifeCover (state, v) {
      state.currentRevenues.life.cases = Number(v)
    },
    setLifeAvgPremium (state, v) {
      state.currentRevenues.life.avgPremium = Number(v)
    },
    setLifeAvgCommission (state, v) {
      state.currentRevenues.life.avgCommission = Number(v)
    },
    setBinsCover (state, v) {
      state.currentRevenues.bins.cases = Number(v)
    },
    setBinsAvgPremium (state, v) {
      state.currentRevenues.bins.avgPremium = Number(v)
    },
    setBinsAvgCommission (state, v) {
      state.currentRevenues.bins.avgCommission = Number(v)
    },
    setPremises (state, v) {
      state.overheads.premises = Number(v)
    },
    setPhone (state, v) {
      state.overheads.phone = Number(v)
    },
    setInsurance (state, v) {
      state.overheads.insurance = Number(v)
    },
    setStaff (state, v) {
      state.overheads.staff = Number(v)
    },
    setSalary (state, v) {
      state.overheads.salary = Number(v)
    },
    setTax (state, v) {
      state.overheads.tax = Number(v)
    },
    setOther (state, v) {
      state.overheads.other = Number(v)
    },
  }
})